import React from 'react';
import './ProjectDetails.css';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faExternalLinkAlt, faCode, faServer } from '@fortawesome/free-solid-svg-icons';
import ProjectSnapshot from '../ProjectSnapshot/ProjectSnapshot';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'var(--bg-secondary, #14171c)',
    color: 'var(--text-primary, #ffffff)',
    border: '1px solid var(--border-subtle, #2d333b)',
    borderRadius: 'var(--radius-lg, 12px)',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    width: '95%',
    maxWidth: '900px',
    maxHeight: '90vh',
    padding: '0',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    backdropFilter: 'blur(8px)',
    zIndex: 1050
  }
};

if (typeof window !== 'undefined' && document.getElementById('root')) {
  Modal.setAppElement('#root');
}

const ProjectDetailsModal = ({ modalIsOpen, closeModal, project }) => {

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Project Details Modal"
      closeTimeoutMS={300}
    >
      <div className="project-modal-wrapper">
        <div className="modal-banner-container" style={{ width: '100%', height: '350px', position: 'relative' }}>
          <ProjectSnapshot url={project.link} title={project.title} />
          <button onClick={closeModal} className="modal-close-btn" aria-label="Close Modal" style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 10, background: 'rgba(0,0,0,0.5)', borderRadius: '50%', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>
            <FontAwesomeIcon icon={faTimesCircle} size="lg" />
          </button>
        </div>

        <div className="modal-content-padding" style={{ padding: '2.5rem' }}>
          <div className="project-modal-header d-flex justify-content-between align-items-center mb-4 pb-3" style={{ borderBottom: '1px solid var(--border-subtle, #2d333b)' }}>
            <h2 className="title__color m-0" style={{ fontWeight: '800', letterSpacing: '-0.5px' }}>{project.title}</h2>
          </div>

          <div className="project-modal-body mb-4">
        <p className="project-description mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-secondary, #b0b3b8)' }}>
          {project.description}
        </p>

        <div className="tech-stack-container row mt-4">
          <div className="col-md-6 mb-3">
            <h5 className="title__color mb-3 d-flex align-items-center">
              <FontAwesomeIcon icon={faCode} className="mr-2" style={{ color: '#61dafb' }} />
              <span className="ml-2">Frontend Tech Stack</span>
            </h5>
            <div className="tech-tags d-flex flex-wrap gap-2">
              {project?.frontendTechnology?.map((tech, index) => (
                <span key={index} className="tech-badge">{tech.technology}</span>
              ))}
            </div>
          </div>
          
          {project?.backendTechnology && (
            <div className="col-md-6 mb-3">
              <h5 className="title__color mb-3 d-flex align-items-center">
                <FontAwesomeIcon icon={faServer} className="mr-2" style={{ color: '#68a063' }} />
                <span className="ml-2">Backend Tech Stack</span>
              </h5>
              <div className="tech-tags d-flex flex-wrap gap-2">
                {project?.backendTechnology?.map((tech, index) => (
                  <span key={index} className="tech-badge">{tech.technology}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="project-modal-footer mt-4 pt-4 d-flex flex-wrap gap-3" style={{ borderTop: '1px solid var(--border-subtle, #2d333b)' }}>
        {project?.link && (
          <a href={project.link} target="_blank" rel="noreferrer" className="portfolio__btn flex-grow-1 text-center font-weight-bold">
            Live Preview <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2" />
          </a>
        )}
        {project?.client && (
          <a href={project.client} target="_blank" rel="noreferrer" className="portfolio__btn portfolio__btn-outline flex-grow-1 text-center font-weight-bold">
            Client Repository <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2" />
          </a>
        )}
        {project?.server && (
          <a href={project.server} target="_blank" rel="noreferrer" className="portfolio__btn portfolio__btn-outline flex-grow-1 text-center font-weight-bold">
            Server Repository <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2" />
          </a>
        )}
      </div>
      </div>
      </div>
    </Modal>
  );
};

export default ProjectDetailsModal;  